module.exports = __webpack_public_path__ + "./images/p14.JPG?6ad824e8f24b405c4b6c957d48faf7f9";


//////////////////
// WEBPACK FOOTER
// ./src/products/p14.JPG
// module id = 49
// module chunks = 0